import {NgModule} from "@angular/core";
import {BaseUrlPipe} from "./baseurl.pipe";
import {BlobPipe} from './blob';
import {DaysDifference} from "./days-difference.pipe";
import {DurationHumanize} from "./duration-humanize.pipe";
import {SafeUrlPipe} from "./safe-url.pipe";
import {SanitizeHtmlPipe} from "./sanitize-html.pipe";
import {TruncatePipe} from "./truncate.pipe";

@NgModule({
  declarations: [
    BaseUrlPipe,
    DaysDifference,
    DurationHumanize,
    SafeUrlPipe,
    SanitizeHtmlPipe,
    TruncatePipe,
    BlobPipe,
  ],
  imports: [],
  exports: [
    BaseUrlPipe,
    DaysDifference,
    DurationHumanize,
    SafeUrlPipe,
    SanitizeHtmlPipe,
    TruncatePipe,
    BlobPipe,
  ],
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts